const closeVto = document.getElementById("close-vto");
const vto = document.getElementById("vto");

function getVtoBtn() {
  return document.getElementById("vto-btn");
}

let currentFrame = vto ? vto.dataset.frame : null;
let availableFrames = new Set();

/**
 * @param {string[]} idTable
 * @returns {Promise<{uid: string, available: boolean}[]>}
 **/
async function getAvailability(idTable) {
  const apiKey = "aHEwyhtPA7js4QBqa23egnZW4tDDktJEgf04rRNd";
  const url = `https://product-api.fittingbox.com/glasses-metadata/availability?apiKey=${apiKey}&uidList=${idTable.join(",")}`;

  const result = await fetch(url);
  if (result.ok) {
    return result.json();
  }

  throw new Error("An error occurred while checking frame availability");
}

/**
 * Generate fallback SKUs based on the pattern: base_color_2, base_color_2_sg, or base_color_2_sp
 * @param {string} sku
 * @returns {string[]}
 */
function getFallbackSkus(sku) {
  if (!sku) return [];

  // Check if it's a sunglasses SKU (ends with _sg)
  const isSunglasses = sku.endsWith("_sg");
  // Check if it's an amber SKU (ends with _sp)
  const isAmber = sku.endsWith("_sp");

  // Extract the base pattern (first two parts, e.g., "nash_c3")
  const parts = sku.split("_");
  if (parts.length < 2) return [];

  const baseName = parts[0]; // e.g., "nash"
  const color = parts[1]; // e.g., "c3"

  const fallbacks = [];

  // 1. Try V2 version: base_color_2 (+ suffix)
  // e.g. nash_c3_r0p5_sp -> nash_c3_2_sp
  let v2Fallback = `${baseName}_${color}_2`;
  if (isSunglasses) {
    v2Fallback += "_sg";
  } else if (isAmber) {
    v2Fallback += "_sp";
  }
  fallbacks.push(v2Fallback);

  // 2. Try clean version: base_color (+ suffix)
  // e.g. nash_c3_r0p5_sp -> nash_c3_sp
  let cleanFallback = `${baseName}_${color}`;
  if (isSunglasses) {
    cleanFallback += "_sg";
  } else if (isAmber) {
    cleanFallback += "_sp";
  }
  fallbacks.push(cleanFallback);

  // 3. For Amber, try non-sp versions as fallback
  if (isAmber) {
    fallbacks.push(`${baseName}_${color}_2`); // V2 base
    fallbacks.push(`${baseName}_${color}`); // Clean base
  }

  console.log(`[VTO] Generated fallback SKUs for "${sku}" →`, fallbacks);
  return fallbacks;
}

/**
 * Get the effective frame to use for VTO, considering fallback logic
 * @param {string} sku
 * @returns {string|null}
 */
function getEffectiveFrame(sku) {
  if (!sku) {
    console.log("[VTO] No SKU provided to getEffectiveFrame");
    return null;
  }

  const normalizedSku = sku.toLowerCase();

  // If the SKU is available, use it
  if (availableFrames.has(normalizedSku)) {
    console.log(`[VTO] Using original SKU: "${normalizedSku}"`);
    return normalizedSku;
  }

  const fallbacks = getFallbackSkus(normalizedSku);

  for (const fallback of fallbacks) {
    if (availableFrames.has(fallback)) {
      console.log(`[VTO] ✓ Fallback SKU "${fallback}" is available - using it`);
      return fallback;
    }
  }

  // No available frame
  console.log(
    `[VTO] ✗ No available frame found for "${normalizedSku}" (fallbacks: ${fallbacks.join(", ")})`,
  );
  return null;
}

// Check availability on page load
async function initializeAvailability() {
  const variantSkus = window.vtoVariantSkus || [];
  const btn = getVtoBtn();

  if (variantSkus.length === 0) {
    if (btn) btn.style.display = "none";
    return;
  }

  // Generate list of all potential IDs to check (original + fallbacks + lowercase variations)
  const skusToCheck = new Set();
  variantSkus.forEach((sku) => {
    if (!sku) return;

    skusToCheck.add(sku);
    skusToCheck.add(sku.toLowerCase());

    const fallbacks = getFallbackSkus(sku);
    fallbacks.forEach((fallback) => {
      skusToCheck.add(fallback);
      skusToCheck.add(fallback.toLowerCase());
    });
  });

  try {
    const availabilityResults = await getAvailability(Array.from(skusToCheck));

    // Store available frames in a Set for quick lookup
    availabilityResults.forEach((result) => {
      if (result.available) {
        availableFrames.add(result.uid.toLowerCase());
      }
    });

    console.log(
      `[VTO] Loaded ${availableFrames.size} available frames:`,
      Array.from(availableFrames),
    );

    // Check if current frame is available
    updateButtonVisibility();
  } catch (error) {
    console.error("Error checking frame availability:", error);
    // On error, hide the button
    const btn = getVtoBtn();
    if (btn) btn.style.display = "none";
  }
}

function updateButtonVisibility() {
  console.log(`[VTO] Updating button visibility for frame: "${currentFrame}"`);
  const effectiveFrame = getEffectiveFrame(currentFrame);
  const btn = getVtoBtn();

  if (!btn) {
    console.log("[VTO] Button not found in DOM");
    return;
  }

  if (effectiveFrame) {
    console.log(`[VTO] Button shown - using frame: "${effectiveFrame}"`);
    btn.style.display = "block";
  } else {
    console.log("[VTO] Button hidden - no available frame");
    btn.style.display = "none";
  }
}

// Optimistically determine the best initial frame (handling raw SKUs like ..._r0p5...)
// independent of availability check (which is async)
const initialFallbacks = getFallbackSkus(currentFrame);
const initialFrame =
  initialFallbacks && initialFallbacks.length > 0
    ? initialFallbacks[0]
    : currentFrame;

let fitmixInstance = null;
let isVtoReady = false;
let pendingStart = false;

function initializeVtoWidget(frameSku) {
  if (!frameSku || !vto) return;

  if (typeof FitMix === "undefined") {
    console.error("[VTO] FitMix library not loaded");
    return;
  }

  // Ensure container is empty before initialization to prevent issues
  vto.innerHTML = "";

  const params = {
    apiKey: "aHEwyhtPA7js4QBqa23egnZW4tDDktJEgf04rRNd",
    onStopVto: hideModule,
    frame: frameSku,
    popupIntegration: {
      centeredHorizontal: true,
      centeredVertical: true,
      width: "640px",
      height: "480px",
    },
    // Add debugging callbacks
    onIssue: function (data) {
      console.warn("[VTO] Issue detected:", data);
    },
    onLiveStatus: function (data) {
      console.log("[VTO] Live status change:", data);
    },
    onOpenStream: function (status) {
      console.log("[VTO] onOpenStream triggered:", status);
    },
  };

  fitmixInstance = FitMix.createWidget(
    "vto",
    params,
    function () {
      console.log("VTO module is ready.");
      isVtoReady = true;

      // Use a timeout to ensure fitmixInstance is assigned and DOM is stable
      if (pendingStart) {
        pendingStart = false;
        console.log("[VTO] Starting pending VTO session...");

        setTimeout(() => {
          if (fitmixInstance && fitmixInstance.startVto) {
            console.log("[VTO] Calling startVto('live')...");
            fitmixInstance.startVto("live");
          } else {
            console.error("[VTO] FitMix instance not found after delay");
            // Attempt recovery if needed, or just log
          }
        }, 250);
      }
    },
    function (error) {
      console.error("Error while initializing the VTO module:", error);
      pendingStart = false;
    },
  );
}

// Remove eager initialization to prevent background suspension or context issues
// if (initialFrame) {
//   initializeVtoWidget(initialFrame);
// }

function hideModule() {
  if (!vto || !closeVto) return;
  vto.style.display = "none";
  closeVto.style.display = "none";
  if (fitmixInstance) fitmixInstance.stopVto();
}

function onCTAButtonClick() {
  if (!vto || !closeVto) return;
  // Ensure the container is visible before initializing/starting
  vto.style.display = "block";
  closeVto.style.display = "block";

  if (fitmixInstance) {
    if (isVtoReady) {
      fitmixInstance.startVto("live");
    } else {
      console.log("[VTO] FitMix instance exists but not ready. Queuing start.");
      pendingStart = true;
    }
  } else if (currentFrame) {
    console.log(
      "[VTO] Attempting lazy initialization with frame:",
      currentFrame,
    );

    // Determine best frame to use for init
    const effectiveFrame = getEffectiveFrame(currentFrame);
    const bestGuess = getFallbackSkus(currentFrame)[0];
    const frameToInit = effectiveFrame || bestGuess || currentFrame;

    // Set pendingStart before initializing so the callback picks it up
    pendingStart = true;
    initializeVtoWidget(frameToInit);
  } else {
    console.error("[VTO] Cannot start VTO: No frame selected");
  }
}

function isVtoOpen() {
  return vto ? vto.style.display === "block" : false;
}

// Listen for variant changes
document.addEventListener("variant:change", function (event) {
  const variant = event.detail?.variant;
  const newFrame = variant?.sku;

  console.log(`[VTO] Variant changed - new SKU: "${newFrame}"`);

  if (newFrame) {
    currentFrame = newFrame;
    if (vto) vto.dataset.frame = newFrame;

    // Check if frame is available before showing button (with fallback logic)
    updateButtonVisibility();

    const effectiveFrame = getEffectiveFrame(newFrame);
    const bestGuess = getFallbackSkus(newFrame)[0];
    const frameToSet = effectiveFrame || bestGuess || newFrame;

    if (!fitmixInstance) {
      console.log(
        `[VTO] Initializing FitMix on variant change with frame: "${frameToSet}"`,
      );
      initializeVtoWidget(frameToSet);
      return;
    }

    // Update the FitMix instance with the effective frame
    if (fitmixInstance && fitmixInstance.setFrame) {
      const vtoIsOpen = isVtoOpen();
      console.log(`[VTO] VTO is ${vtoIsOpen ? "open" : "closed"}`);

      if (vtoIsOpen) {
        // If VTO is open, set the effective frame (or best guess fallback if not confirmed available)
        const bestGuess = getFallbackSkus(newFrame)[0];
        const frameToSet = effectiveFrame || bestGuess || newFrame;
        console.log(
          `[VTO] Setting FitMix frame to: "${frameToSet}" (VTO open)`,
        );
        fitmixInstance.setFrame(frameToSet);
      } else if (effectiveFrame) {
        // If VTO is closed, only set frame if we have an effective (available) frame
        console.log(
          `[VTO] Setting FitMix frame to: "${effectiveFrame}" (VTO closed)`,
        );
        fitmixInstance.setFrame(effectiveFrame);
      } else {
        console.log(
          "[VTO] Not setting FitMix frame - no effective frame available",
        );
      }
    }
  } else {
    // Hide button if no SKU available
    console.log("[VTO] No SKU in variant - hiding button");
    currentFrame = null;
    const btn = getVtoBtn();
    if (btn) btn.style.display = "none";
  }
});

// PDP-only initialization (requires #vto and #close-vto elements)
if (vto && closeVto) {
  initializeAvailability();

  document.addEventListener("click", function (event) {
    if (event.target && event.target.closest("#vto-btn")) {
      onCTAButtonClick();
    }
  });

  closeVto.addEventListener("click", hideModule);
}

// Expose a debug method to set the frame manually from the console
window.frame = function (sku) {
  if (!sku) {
    console.error(
      "[VTO Debug] Please provide a SKU, e.g., frame('nash_c10_sp')",
    );
    return;
  }

  console.log(`[VTO Debug] Manual frame set requested: "${sku}"`);

  if (fitmixInstance && fitmixInstance.setFrame) {
    const effectiveFrame = getEffectiveFrame(sku);
    const frameToSet = effectiveFrame || sku;

    console.log(`[VTO Debug] Setting FitMix frame to: "${frameToSet}"`);
    fitmixInstance.setFrame(frameToSet);

    // Also update internal state
    currentFrame = sku;
    if (vto) vto.dataset.frame = sku;
    updateButtonVisibility();
  } else {
    console.error(
      "[VTO Debug] FitMix instance not ready or setFrame method missing",
    );
  }
};
document
  .querySelectorAll(
    'a[href="/pages/virtual-try-on"], a[href="#virtual-try-on"]',
  )
  .forEach(function (element) {
    element.addEventListener("click", function (event) {
      if (vto && closeVto) {
        // PDP: open inline VTO widget
        event.preventDefault();
        event.stopImmediatePropagation();
        onCTAButtonClick();
      } else if (typeof window.openVtoSectionModal === "function") {
        // All other pages: open the vto-section.liquid modal
        event.preventDefault();
        event.stopImmediatePropagation();
        window.openVtoSectionModal();
      }
    });
  });
